// src/app/shared/services/edit/hunt-editor.service.ts
import { Injectable, inject } from '@angular/core'

import { Enums, Hunt } from '@cyborg-monorepo/hunter/common'

import { SessionService } from '../session.service'
import { UndoRedoService } from '../undo-redo.service'

@Injectable({ providedIn: 'root' })
export class HuntEditorService {
  private readonly session = inject(SessionService)
  private readonly undoRedo = inject(UndoRedoService<Hunt>)

  /** Update the hunt's name */
  updateName(name: string): void {
    const hunt = this.session.activeHunt()
    if (!hunt) return

    this.undoRedo.push(hunt)
    const updated = { ...hunt, name }

    this.session.activeHunt.set(updated)
  }

  /** Update the hunt's abstract */
  updateAbstract(abstractText: string): void {
    const hunt = this.session.activeHunt()
    if (!hunt) return

    this.undoRedo.push(hunt)
    const updated = { ...hunt, abstract: abstractText }

    this.session.activeHunt.set(updated)
  }

  /** Update the hunt's hypothesis */
  updateHypothesis(hypothesis: string): void {
    const hunt = this.session.activeHunt()
    if (!hunt) return

    this.undoRedo.push(hunt)
    const updated = { ...hunt, hypothesis }

    this.session.activeHunt.set(updated)
  }

  /** Update the hunt's conclusion */
  updateConclusion(conclusion: string): void {
    const hunt = this.session.activeHunt()
    if (!hunt) return

    this.undoRedo.push(hunt)
    const updated = { ...hunt, conclusion }
    this.session.activeHunt.set(updated)
  }

  /** Update the executive summary */
  updateExecutiveSummary(executiveSummary: string): void {
    const hunt = this.session.activeHunt()
    if (!hunt) return

    this.undoRedo.push(hunt)
    const updated = { ...hunt, executiveSummary }

    this.session.activeHunt.set(updated)
  }

  /** Update analyst notes */
  updateNotes(notes: string): void {
    const hunt = this.session.activeHunt()
    if (!hunt) return

    this.undoRedo.push(hunt)
    const updated = { ...hunt, notes }

    this.session.activeHunt.set(updated)
  }

  /** Update the hunt's outcome */
  updateOutcome(outcome: Enums.OutcomeEnum): Promise<void> {
    const hunt = this.session.activeHunt()
    if (!hunt) return Promise.resolve()

    this.undoRedo.push(hunt)
    const updated = { ...hunt, outcome }

    this.session.activeHunt.set(updated)
  }

  /** Update the dependent field for the outcome */
  updateOutcomeDependent(outcomeDependent: string): void {
    const hunt = this.session.activeHunt()
    if (!hunt) return

    this.undoRedo.push(hunt)
    const updated = { ...hunt, outcomeDependent }

    this.session.activeHunt.set(updated)
  }

  /** Update priority */
  updatePriority(priority: Enums.PriorityEnum): void {
    const hunt = this.session.activeHunt()
    if (!hunt) return

    this.undoRedo.push(hunt)
    const updated = { ...hunt, priority }

    this.session.activeHunt.set(updated)
  }

  /** Update status */
  updateStatus(status: Enums.StatusEnum): Promise<void> {
    const hunt = this.session.activeHunt()
    if (!hunt) return Promise.resolve()

    this.undoRedo.push(hunt)
    const updated = { ...hunt, status }

    this.session.activeHunt.set(updated)
  }

  /** Toggle editing flag */
  updateEditing(editing: boolean): Promise<void> {
    const hunt = this.session.activeHunt()
    if (!hunt) return Promise.resolve()

    this.undoRedo.push(hunt)
    const updated = { ...hunt, editing }

    this.session.activeHunt.set(updated)
  }
}
